{
  "version": 1,
  "asset_id": "02fb2816-7acb-478c-9c51-965fa3cb14b6",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/02fb2816-7acb-478c-9c51-965fa3cb14b6/capital-pro-services.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/02fb2816-7acb-478c-9c51-965fa3cb14b6/capital-pro-services.mp4",
  "original_filename": "capital-pro-services.mp4",
  "size": 4965827,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:37:05Z"
}
